import { prefersReducedMotion } from '../lib/lenis';

// Hero entrance: badge → title → subtitle → CTAs stagger in on load, then
// the app frame rises. States live in CSS (html.js gate); we only add the
// per-element delay and the reveal class.
export function initHeroIntro(): void {
  const els = Array.from(document.querySelectorAll<HTMLElement>('[data-hero-el]'));
  const frame = document.querySelector<HTMLElement>('[data-hero-frame]');

  if (prefersReducedMotion()) {
    els.forEach((el) => el.classList.add('is-revealed'));
    frame?.classList.add('is-revealed');
    return;
  }

  els.forEach((el, i) => el.style.setProperty('--reveal-delay', `${(0.09 * i).toFixed(2)}s`));

  window.setTimeout(() => {
    els.forEach((el) => el.classList.add('is-revealed'));
    frame?.classList.add('is-revealed');
  }, 70);
}
